import React from 'react';
import css from './WhySection.module.css';

const WhySection = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.sectionsWrapper}>
        <div className={css.left}>
          <p className={css.title}>Why Scanwow? Built for creators. Backed by community.</p>
          <p className={css.description}>
            Scanwow isn’t just another 3d asset marketplace—it’s a space purpose-built for makers.
            Whether you’re scanning, selling, or sourcing, we’ve designed everything with your
            creative flow in mind.
          </p>
          <p className={css.descriptionSmall}>
            From flexible tools to fair payouts, we’ve got your back—because we’re creators too.
          </p>
        </div>
        <div className={css.right}>
          <p className={css.rightItem}>A platform made by makers, for makers.</p>
          <p className={css.rightItem}>Flexible licensing for real-world projects.</p>
          <p className={css.rightItem}>Creator-first revenue model.</p>
          <p className={css.rightItem}>We speak scan: all formats are welcome.</p>
          <p className={css.rightItemLast}>Not just a marketplace – a knowledge hub.</p>
        </div>
      </div>
    </div>
  );
};

export default WhySection;
